import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../Helper/admin'
import { useLocation } from 'react-router'
import { isPageAllowed } from '../utils/adminRoles'
import { ADMIN_LOGIN } from '../Constant'
import AccessDenied from '../Components/Location/AccessDenied'
import { addAdminActivity } from '../firebase/utils'

const LocationLayout = ({ children }) => {
  const { setLocation, user, location: coordination } = useContext(AdminContext)
  const [error, setError] = useState("");
  const [userLoaded, setUserLoaded] = useState(false);
  const [isPageAllow, setPageAllow] = useState(true);
  const location = useLocation()
  console.log('coordination', coordination)
  console.log('error', error)
  console.log("isPageAllow", isPageAllow)

  useEffect(() => {
    if (user) {
      const pageRoute = location.pathname.split('/')[1]
      getUserCoordinates(user);
      setUserLoaded(true);
      if (user.isSuperAdmin) return
      const isAllow = isPageAllowed(user.permissions, pageRoute) || pageRoute === '';
      setPageAllow(isAllow)

      // if (location.pathname === "/auth" && user.isAdmin) {
      //   setPageAllow(true)
      //   router.push("/");
      // }
    }
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
    if (coordination) {
      trackAdminLoginActivity(
        `Admin with email ${user?.email} has logged into the admin portal.`,
        user, localStorage.getItem('refresh_tracked')
      );
    } else {
      trackAdminLoginActivity(
        `ALERT: Admin with email ${user?.email} has logged into the admin portal.`,
        user, localStorage.getItem('refresh_tracked')
      );
    }
  };

  const getUserCoordinates = (loginUser) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            long: position.coords.longitude,
          })
          trackAdminLoginActivity(
            `Admin with email ${loginUser?.email} has logged into the admin portal.`,
            loginUser,
            false,
            {
              lat: position.coords.latitude,
              long: position.coords.longitude,
            }
          );
          localStorage.setItem("admin_login", true);
        },
        (error) => {
          console.log(error.message);
          trackAdminLoginActivity(
            `ALERT: Admin with email ${loginUser?.email} has logged into the admin portal.`,
            loginUser, localStorage.getItem('refresh_tracked')
          );
          localStorage.setItem('refresh_tracked', true)
          setError("Location access denied by user.");
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
      trackAdminLoginActivity(
        `ALERT: Admin with email ${loginUser?.email} has logged into the admin portal.`,
        loginUser
      );
    }
  };

  const trackAdminLoginActivity = (activity, loginUser, isRefreshTracked, location) => {
    const isAlreadyTracked = JSON.parse(localStorage.getItem("admin_login"));
    if (!isAlreadyTracked && !isRefreshTracked && loginUser) {
      const activityOptions = {
        adminId: loginUser?.email,
        activityOnUser: "N/A",
        type: ADMIN_LOGIN,
        createdAt: new Date(),
      };
      activityOptions.activity = activity;
      addAdminActivity(activityOptions, location);
      localStorage.setItem('refresh_tracked', true)
    }
  };
  return (
    <div>
      {coordination ?
        isPageAllow ?
          <>
            {children}
          </>
          :
          <AccessDenied coordination={coordination} setPageAllow={setPageAllow} />
        :
        error.includes('denied by user') ?
          <AccessDenied /> : ''
      }

    </div>
  )
}

export default LocationLayout